import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Button, ButtonProps, Collapse, CollapseProps } from "@mui/material";
import { useState } from "react";

type CollapsibleProps = {
  buttonProps?: ButtonProps;
  collapsibleProps?: CollapseProps;
  children: React.ReactNode;
};

export const Collapsible = (slotProps: CollapsibleProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        variant="text"
        endIcon={open ? <ExpandLess /> : <ExpandMore />}
        {...slotProps.buttonProps}
      >
        {slotProps.buttonProps?.children || "View Details"}
      </Button>
      <Collapse in={open} {...slotProps.collapsibleProps}>
        {slotProps?.children}
      </Collapse>
    </>
  );
};
